// Helpers para armar query strings de endpoints GET.
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)

const tieneValor = (valor) => {
  if (valor === null || valor === undefined) return false;
  if (Array.isArray(valor)) return valor.length > 0;
  return String(valor).trim() !== "";
};

// Arma "?a=1&b=x" solo con los parámetros que tienen valor (no manda cadenas vacías).
// Los arreglos se envían como lista separada por coma.
export const construirQuery = (parametros = {}) => {
  const partes = Object.entries(parametros)
    .filter(([, valor]) => tieneValor(valor))
    .map(([clave, valor]) => {
      const texto = Array.isArray(valor) ? valor.join(",") : String(valor).trim();
      return `${encodeURIComponent(clave)}=${encodeURIComponent(texto)}`;
    });
  return partes.length ? `?${partes.join("&")}` : "";
};

// [1, 5, 8] → "1,5,8". Si no hay selección devuelve el valor "todos" (por defecto "0").
export const idsACadena = (ids = [], valorTodos = "0") =>
  Array.isArray(ids) && ids.length > 0 ? ids.join(",") : valorTodos;
